module.exports = __webpack_public_path__ + "img/store-huawei-en.516f0dd.png";